import type { ReactNode } from "react";

type PageHeaderProps = {
  title?: string;
  description?: string;
  actions?: ReactNode;
};

/** Page toolbar. When `title` is omitted, only description/actions render (shell provides the title). */
export const PageHeader = ({ title, description, actions }: PageHeaderProps) => {
  if (title == null) {
    if (description == null && actions == null) {
      return null;
    }
    return (
      <div className="admin-page-toolbar">
        {description != null ? <p className="admin-page-toolbar-desc">{description}</p> : null}
        {actions != null ? <div className="admin-page-toolbar-actions">{actions}</div> : null}
      </div>
    );
  }

  return (
    <div className="admin-page-header">
      <div className="admin-page-header-text">
        <h1 className="admin-page-title">{title}</h1>
        {description != null ? <p className="admin-page-description">{description}</p> : null}
      </div>
      {actions != null ? <div className="admin-page-header-actions">{actions}</div> : null}
    </div>
  );
};
